import { render, staticRenderFns } from "./Socioassistencial.vue?vue&type=template&id=11e93985"
import script from "./Socioassistencial.vue?vue&type=script&lang=js"
export * from "./Socioassistencial.vue?vue&type=script&lang=js"
import style0 from "./Socioassistencial.vue?vue&type=style&index=0&id=11e93985&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports